import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetPublishedConnectionTableDescriptionParams {
  readonly id: string;
  readonly description: string;
}

export interface SetPublishedConnectionTableDescriptionResult extends IResult {
}

export class SetPublishedConnectionTableDescriptionRequest extends Request<SetPublishedConnectionTableDescriptionParams, SetPublishedConnectionTableDescriptionResult> {
  constructor(params: SetPublishedConnectionTableDescriptionParams) {
    super('setPublishedConnectionTableDescription', params);
  }
}
